export default "__VITE_ASSET__C$OGaOVd__"